// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1Cw0l","checkboxCol":"Table_checkboxCol__13ZTp","emailCol":"Table_emailCol__T-1Rh","actionCol":"Table_actionCol__SnkBv"};